module.exports = __webpack_public_path__ + "static/media/model-pajero-00-lwb.aa27e591.webp";